import { Injectable } from "@angular/core";

@Injectable()
export class NearbyParticipantService {

}

export enum ParticipantsPageMode {
    DEFAULT,
    LOCATION_EXPORT
} 


// WEBPACK FOOTER //
// /src/providers/nearby-participants.service.ts